/**
 * @function dataReference
 * @memberof adapters.ToSeekAPI
 * @inner
 * @param {data-references.DataReference} toSeek
 * @return {SeekDataReference}
 */
export function dataReference(toSeek) {
    return {
        type: toSeek.type,
        column: toSeek.column.toString(),
        sourceId: toSeek.sourceId,
    };
}
/**
 * @function dataReferenceCollection
 * @memberof adapters.ToSeekAPI
 * @inner
 * @param {data-references.DataReferenceCollection} toSeek
 * @return {object}
 */
export function dataReferenceCollection(toSeek) {
    var _a;
    return {
        id: typeof toSeek.id === 'number' ? toSeek.id : null,
        variables: ((_a = toSeek.variables) !== null && _a !== void 0 ? _a : []).map(dataReference),
        query: {
            type: toSeek.query.type,
            parameters: toSeek.query.parameters,
        },
    };
}
/**
 * @function dataImplementation
 * @memberof adapters.ToSeekAPI
 * @inner
 * @param {data-references.DataImplementation} toSeek
 * @return {object}
 */
export function dataImplementation(toSeek) {
    const { hasNormalization } = toSeek;
    return {
        ...toSeek,
        ref: dataReferenceCollection(toSeek.ref),
        normalization: (hasNormalization
            ? dataReferenceCollection(toSeek.normalization.ref)
            : undefined),
    };
}
/**
 * @function featureReference
 * @memberof adapters.ToSeekAPI
 * @inner
 * @param {SeekFeatureReference} toSeek
 * @return {feature-references.FeatureReference}
 */
export function featureReference(toSeek) {
    return {
        featureId: toSeek.id,
        type: toSeek.type,
        sourceId: toSeek.sourceId,
    };
}
/**
 * @function featureReferenceCollection
 * @memberof adapters.ToSeekAPI
 * @inner
 * @param {feature-references.FeatureReferenceCollection} toSeek
 * @return {object}
 */
export function featureReferenceCollection(toSeek) {
    var _a;
    return {
        features: ((_a = toSeek.features) !== null && _a !== void 0 ? _a : []).map(featureReference),
        query: {
            pattern: toSeek.query.pattern,
            parameters: toSeek.query.parameters,
        },
    };
}
/**
 * @function collections
 * @memberof adapters.ToSeekAPI
 * @inner
 * @param {object} toSeek
 * @param {?data-references.DataImplementation[]} toSeek.dataImplementations
 * @param {?data-references.DataReferenceCollection[]} toSeek.dataReferenceCollections
 * @param {?feature-references.FeatureReferenceCollection[]} toSeek.featureReferenceCollections
 * @return {object}
 */
export function collections({ dataImplementations, dataReferenceCollections, featureReferenceCollections, }) {
    const features = (featureReferenceCollections
        ? featureReferenceCollections.map(featureReferenceCollection)
        : featureReferenceCollections);
    const dataReferences = (dataReferenceCollections
        ? dataReferenceCollections.map(dataReferenceCollection)
        : dataReferenceCollections);
    const implementations = (dataImplementations
        ? dataImplementations.map(dataImplementation)
        : dataImplementations);
    return {
        featureReferenceCollections: features,
        dataReferenceCollections: dataReferences,
        dataImplementations: implementations,
    };
}
/**
 * @namespace
 * @memberof adapters
 */
const ToSeekAPI = {
    dataReference,
    dataReferenceCollection,
    dataImplementation,
    featureReference,
    featureReferenceCollection,
    collections,
};
export default ToSeekAPI;
